import type { ScriptElementDto, ScriptElementFormState } from '../../types/script'
import { uuid } from '../../lib/uuid'

export function mapElementDtosToFormState(
  dtos: ScriptElementDto[]
): ScriptElementFormState[] {
  // Pass 1: Generate clientIds and build serverGuid → clientId map
  const idToClientId = new Map<string, string>()
  for (const dto of dtos) {
    idToClientId.set(dto.id, uuid())
  }

  // Pass 2: Map DTOs to form state, resolving FK references to clientIds
  return dtos
    .map((dto) => ({
      clientId: idToClientId.get(dto.id)!,
      elementType: dto.elementType,
      displayOrder: dto.displayOrder,
      parentClientId: dto.parentElementId
        ? idToClientId.get(dto.parentElementId) ?? null
        : null,
      nextElementClientId: dto.nextElementId
        ? idToClientId.get(dto.nextElementId) ?? null
        : null,
      textContent: dto.textContent ?? undefined,
      textContentSpanish: dto.textContentSpanish ?? undefined,
      surveyQuestionId: dto.surveyQuestionId ?? null,
      tagId: dto.tagId ?? null,
      conditionalField: dto.conditionalField ?? undefined,
      conditionalOperator: dto.conditionalOperator ?? undefined,
      conditionalValue: dto.conditionalValue ?? undefined,
      nextElementOnTrueClientId: dto.nextElementOnTrue
        ? idToClientId.get(dto.nextElementOnTrue) ?? null
        : null,
      nextElementOnFalseClientId: dto.nextElementOnFalse
        ? idToClientId.get(dto.nextElementOnFalse) ?? null
        : null,
      // Map answerBranches: server GUIDs in values → clientIds
      answerBranches: dto.answerBranches
        ? Object.fromEntries(
            Object.entries(dto.answerBranches)
              .map(([answerId, targetElementId]) => [
                answerId,
                idToClientId.get(targetElementId) ?? '',
              ])
              .filter(([, clientId]) => clientId !== '')
          )
        : undefined,
      promptText: dto.promptText ?? undefined,
      // Map promptResponses: server GUIDs → clientIds
      promptResponses: dto.promptResponses
        ? dto.promptResponses.map((pr) => ({
            label: pr.label,
            targetClientId: pr.targetElementId
              ? idToClientId.get(pr.targetElementId) ?? null
              : null,
          }))
        : undefined,
    }))
    .sort((a, b) => a.displayOrder - b.displayOrder)
}
